import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="bg-warm-bg" data-id="element-166">
      {/* Image displayed cleanly without overlay text */}
      <div className="w-full" data-id="element-167">
        <img src="https://cdn.magicpatterns.com/uploads/4SH8JPbcFcdTgBjj9FvpcD/heylloyd-image-1776989235459.png" alt="Espalda Libre – Una historia real de recuperación" className="w-full h-auto object-cover" data-id="element-168" />
      </div>

      {/* Content below the image */}
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-20 text-center" data-id="element-169">
        <FadeIn delay={0.1} data-id="element-170">
          <span className="inline-block py-1.5 px-4 rounded-full bg-warm-accent/10 text-warm-accent text-sm font-medium tracking-wider uppercase mb-8 border border-warm-accent/20" data-id="element-171">
            Ebook Digital
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-172">
          <h1 className="text-3xl md:text-5xl lg:text-6xl text-warm-dark font-heading font-medium leading-tight mb-6" data-id="element-173">
            Lo que me hubiera gustado saber el día que me{' '}
            <span className="italic text-warm-accent" data-id="element-174">diagnosticaron</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-175">
          <p className="text-lg md:text-xl text-warm-dark/70 font-light max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-176">
            Una guía honesta, humana y práctica para acompañarte en tu proceso
            de recuperación del dolor de espalda, sin promesas milagrosas.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-177">
          <div className="flex flex-col items-center gap-4" data-id="element-178">
            <Button href="#comprar" className="text-lg px-10 py-5 w-full sm:w-auto" data-id="element-179">
              Quiero mi guía ahora
            </Button>
            <p className="font-heading text-2xl text-warm-dark mt-2" data-id="element-180">
              Solo $14.99 USD.{' '}
              <span className="text-warm-accent italic" data-id="element-181">Pago Único</span>
            </p>
            <p className="text-warm-dark/60 text-sm mt-4 flex items-center gap-2 font-light" data-id="element-182">
              <svg className="w-4 h-4 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-183">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-184" />
              </svg>
              Basado en 9 meses de experiencia real de recuperación
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}